import React, { useState } from "react";
import "./LoginPage.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { storeToken } from "../../utils/AuthStorage";
import toast, { Toaster } from 'react-hot-toast';
import {
  Modal,
  Box,
  Typography,
  IconButton,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { FaTimes, FaEye, FaEyeSlash } from "react-icons/fa";
import Loading from "../Loading";
import { getFirstAccessibleRoute } from "../../utils/routeUtils";

const LoginPage = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [userRole, setUserRole] = useState("Company");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let url = "";
    switch (userRole) {
      case "Admin":
        url = `${process.env.REACT_APP_URL}/superadmin/login`;
        break;
      case "Company":
        url = `${process.env.REACT_APP_URL}/company/login`;
        break;
      case "Employee":
        url = `${process.env.REACT_APP_URL}/user/login`;
        break;
      default:
        url = `${process.env.REACT_APP_URL}/superadmin/login`;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user/login`,
        {
          email: email,
          password: password,
        },
        {
          headers: {
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      // if (response.data?.access_token) {
      //   storeToken(response.data.access_token, userRole);
      //   navigate("/dashboard");
      // } else {
      //   toast.error("Login failed. Please check your credentials.");
      // }

          const token = response.data?.access_token;
          const rtoken = response.data?.refresh_token;
          const name = response.data?.user?.name;
          const roleuser = response.data?.user?.role?.name;
    if (token) {
      localStorage.setItem("tokenInv", token);
      localStorage.setItem("refreshTokenInv", rtoken);
      localStorage.setItem("userName", name);
      localStorage.setItem("userRole", roleuser);
const role = response?.data?.company?.role || "unknown";
  localStorage.setItem("roleInv", role); 

      const decoded = JSON.parse(atob(token.split(".")[1]));
        const roleId = response.data?.user?.role_id || decoded?.sub?.role_id;

        if (roleId) {
          await fetchPermissions(roleId);
        }

      // navigate("/dashboard");
      const firstRoute = getFirstAccessibleRoute();
navigate(firstRoute);

    } else {
      toast.error("Login failed. Please check your credentials.");
    }

    } catch (error) {
      console.error("Login error:", error);
      toast.error(
        error?.response?.data?.error || "Something went wrong. Please try again."
      );

    }  finally {
    setIsLoading(false);
  }
  };

const fetchPermissions = async (roleId) => {
  const token = localStorage.getItem("tokenInv");

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_URL}/api/permission-modules?role_id=${roleId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      }
    );

    const data = response.data || [];

    // 1. Prepare combined rows for UI table (as you're doing already)
    let combinedRows = [];

    // 2. Prepare simplified permission array for internal use (prefix-wise)
    let simplifiedPermissions = [];

    data.forEach((module) => {
      // For UI
      combinedRows.push({
        id: `module-${module.id}`,
        isModuleHeader: true,
        moduleName: module.name,
      });

      module.permissions.forEach((perm) => {
        // Push to combinedRows for UI
        combinedRows.push({
          id: `${module.id}-${perm.id}`,
          permission_id: perm.id,
          moduleName: module.name,
          permissionName: perm.name,
          view: perm.show_view ? perm.privileges?.is_view || false : null,
          add: perm.show_add ? perm.privileges?.is_add || false : null,
          edit: perm.show_edit ? perm.privileges?.is_edit || false : null,
          delete: perm.show_delete ? perm.privileges?.is_delete || false : null,
          isModuleHeader: false,
        });

        // Push to simplified permissions
        simplifiedPermissions.push({
          id: perm.id,
          name: perm.name,
          prefix: perm.prefix,
          privileges: perm.privileges || {},
        });
      });
    });

    // Store both in localStorage
    // localStorage.setItem("permissions", JSON.stringify(combinedRows));
    localStorage.setItem("permissionsEssential", JSON.stringify(simplifiedPermissions));

  } catch (error) {
    console.error("Failed to fetch permissions:", error);
  }
};



  const handleOpenModal = (content) => {
    setModalContent(content);
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
      {isLoading && <Loading />}
      <div className="container">
        {/* Left Side */}
        <div className="leftSide">
          <img
            src="https://login.thepresence360.com/images/thepresence.png"
            alt="Presence Logo"
            className="logo"
          />
          <div className="imageContainer">
            <img
              src="/login-bg-newimage-new.svg"
              alt="Login background"
              className="backgroundImage"
            />
          </div>
          <h2 className="leftHeading">
            360-degree presence across organization
          </h2>
        </div>

        {/* Right Side */}
        <div className="rightSide">
          <h1 className="rightHeading">
            Welcome Aboard, <br />
            <span className="rightHeading1">
              Please sign-in to your account with mail or mobile and start to
              Explore
            </span>
          </h1>
          {/* <div>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">
                User Role
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                onChange={(e) => {
                  setUserRole(e.target.value);
                }}
                value={userRole}
              >
                {/* <FormControlLabel
                  value="Admin"
                  control={<Radio />}
                  label="Admin"
                /> */}
               {/* <FormControlLabel
                  value="Company"
                  control={<Radio />}
                  label="Admin"
                />
                <FormControlLabel
                  value="Employee"
                  control={<Radio />}
                  label="User"
                />
              </RadioGroup>
            </FormControl>
          </div> */}
          <form className="form" onSubmit={handleLogin}>
            <div>
              <label>Email</label>
              <input
                type="email"
                className="input"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label>Password</label>
              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  className="input"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <IconButton
                  onClick={togglePasswordVisibility}
                  className="eye-icon"
                  sx={{
                    position: "absolute",
                    right: "10px", // Adjust as needed to space from right edge
                    top: "35%",
                    transform: "translateY(-50%)",
                    zIndex: 1, // Ensure the icon appears above the input field
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </IconButton>
              </div>
            </div>

            <div className="terms">
              <input type="checkbox" required />
              <span style={{marginLeft:"10px"}}>
                I hereby agree to the{" "}
                <span
                  className="tandc"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpenModal("Terms & Conditions")}
                >
                  Terms & Conditions
                </span>{" "}
                and{" "}
                <span
                  className="tandc"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpenModal("Privacy Policy")}
                >
                  Privacy Policy
                </span>
              </span>{" "}
            </div>
            <button type="submit" className="loginButton">
              Login
            </button>
          </form>
        </div>
      </div>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <IconButton
            onClick={handleCloseModal}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <FaTimes />
          </IconButton>
          <Typography
            variant="h6"
            component="h2"
            sx={{ fontSize: "16px", fontWeight: "bold" }}
          >
            {modalContent}
          </Typography>
          <Typography sx={{ mt: 2, fontSize: "12px" }}>
            {modalContent === "Terms & Conditions"
              ? `By using this service, you agree to abide by our rules and regulations. All activities must comply with the company policies. 
              Any misuse or violation may result in account suspension. Users must maintain confidentiality of their credentials. 
              Transactions made through this platform are subject to verification. The company reserves the right to modify terms at any time.
              Additional policies include compliance with financial regulations, adherence to ethical standards, and zero tolerance for fraudulent activities.
              Unauthorized access attempts will be prosecuted, and data privacy is a top priority.`
              : `We value your privacy and ensure that your data is protected. Your personal information will not be shared without your consent. 
              We use secure encryption to store sensitive data. Users have the right to request data deletion. We comply with GDPR and other data protection laws. 
              Analytics data is used to improve our services, but no personal information is sold to third parties.
              Your data is never shared with advertisers, and we implement regular security audits to ensure maximum protection.`}
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default LoginPage;
